import { DataGridTypes } from 'devextreme-react/data-grid';

import FieldTypeReferenceDto from '../../classes/dtos/FieldTypeReferenceDto';
import FieldTypeTag from './FieldTypeTag';

/**
 * Shared DataGrid `cellRender` for a column whose row exposes a `Type: FieldTypeReferenceDto`
 * (the SOURCE field type in the MetaApi / Reporting / AI / DataTable mapping grids and the
 * TARGET field type in the Synchro grid). Replaces five byte-identical per-grid copies.
 */
const FieldTypeCell = (cellData: DataGridTypes.ColumnCellTemplateData) => (
    <FieldTypeTag FieldType={(cellData.data as { Type: FieldTypeReferenceDto }).Type} />
);

export default FieldTypeCell;
